module.exports = __webpack_public_path__ + "img/311.146a9f5d.png";